var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycpending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1120,
    height: 336,
    viewBox: "0 0 1120 336",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3660_2511)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 336,
    rx: 15,
    fill: "url(#paint0_linear_3660_2511)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3660_2511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 60,
    width: 742,
    height: 234,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3660_2511",
    x: -27,
    y: -20,
    width: 902,
    height: 394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_3660_2511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3660_2511",
    x1: 560,
    y1: 0,
    x2: 560,
    y2: 336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3660_2511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 336,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycpending);
export default __webpack_public_path__ + "static/media/Kycpending.82b8b9252908382f07a5ef3b60531ffc.svg";
export { ForwardRef as ReactComponent };